import { useEffect } from "react";
import { BrowserRouter, Routes, Route, useLocation } from "react-router-dom";
import { AuthProvider } from "@/context/AuthContext";
import { Toaster } from "@/components/ui/sonner";
import Layout from "@/pages/Layout";
import Home from "@/pages/Home";
import Tools from "@/pages/Tools";
import Games from "@/pages/Games";
import Blog from "@/pages/Blog";
import BlogPost from "@/pages/BlogPost";
import NewsPage from "@/pages/NewsPage";
import Admin from "@/pages/Admin";
import CostSheetPage from "@/pages/CostSheetPage";

function ScrollToTop() {
  const { pathname } = useLocation();
  useEffect(() => { window.scrollTo(0, 0); }, [pathname]);
  return null;
}

function App() {
  return (
    <AuthProvider>
      <BrowserRouter>
        <ScrollToTop />
        <Routes>
          <Route element={<Layout />}>
            <Route path="/" element={<Home />} />
            <Route path="/tools" element={<Tools />} />
            <Route path="/games" element={<Games />} />
            <Route path="/blog" element={<Blog />} />
            <Route path="/blog/:slug" element={<BlogPost />} />
            <Route path="/news" element={<NewsPage />} />
            <Route path="/cost-sheet" element={<CostSheetPage />} />
            <Route path="/admin" element={<Admin />} />
          </Route>
        </Routes>
      </BrowserRouter>
      <Toaster position="top-right" theme="light" />
    </AuthProvider>
  );
}

export default App;
